import Store from '../store/store'

export default {
    computed: {
        user() {
            return Store.state.user
        }
    },
    methods: {
        getUserSoundKits(page, limit = 20, filter = {}) {
            const filterQuery = this.filterToQuery(filter)
            return this.$http.get(`${ab.apiUrl}/users/${this.user.id}/kits`, {params: {page: page, limit: limit, order: 'latest', ...filterQuery}})
        },
        getUserSoundkitItems(soundkitId, page, limit = 20) {
            return this.$http.get(`${ab.apiUrl}/users/${this.user.id}/kits/${soundkitId}/items`, {params: {page, limit}})
        },
        getUserSoundKit(id) {
            return this.$http.get(`${ab.apiUrl}/users/${this.user.id}/kits/${id}`)
        },
        filterToQuery(filter) {
            const {
                types,
                tags,
                instruments,
                added,
                sortBy
            } = filter

            const getName = (item) => item.name
            const filterQuery = {}

            if (tags && tags.length) {
                filterQuery.tags = tags.map(getName)
            }

            if (types && types.length) {
                filterQuery.sound_types = types.map(getName)
            }

            if (instruments && instruments.length) {
                filterQuery.instruments = instruments.map(getName)
            }

            if (added) {
                filterQuery.added = added.id
            }

            if (sortBy) {
                filterQuery.order = sortBy.id
            }

            return filterQuery
        }
    }

}
